<template>
  <div :class="{ 'pad-top': !state.token }" class="dashboard-container">
    <SideBar v-if="state.token" />
    <div class="headet-tabs">
      <div v-if="state.token" class="navbar">
        <div>
          <a @click.prevent="$router.push({ name: 'Market' })" href="">
            بازار
          </a>
          <a @click.prevent="$router.push({ name: 'Faq' })" href="">
            راهنمای استفاده
          </a>
          <a @click.prevent="$router.push({ name: 'Fee' })" href="">
            کارمزد ها
          </a>
        </div>

        <!-- <label class="switch">
          <input
            @change="changeTheme"
            type="checkbox"
            v-model="checked"
            hidden
          />
          <span class="slider" />
          <img src="@/assets/Moon.svg" alt="moon" class="moon" />
          <img src="@/assets/Sun.svg" alt="sun" class="sun" />
        </label> -->
      </div>
      <CoinHeader
        :key="$route.params.tradeTo + $route.params.tradeFrom + 'wt'"
        :marketTradeInfo="marketTradeInfo"
      />
    </div>
    <div class="column-container">
      <div class="right-column">
        <div class="content-container">
          <div class="market-view">
            <CoinList
              :key="$route.params.tradeTo + $route.params.tradeFrom + 'cl'"
              :tickerPrices="tickerPrices"
            />
            <TradingView
              :key="$route.params.tradeTo + $route.params.tradeFrom + 'tr'"
            />
          </div>
          <div class="trades-defth">
            <LastTrades
              :key="$route.params.tradeTo + $route.params.tradeFrom + 'lt'"
            />
            <Defth
              :key="$route.params.tradeTo + $route.params.tradeFrom + 'df'"
            />
          </div>
          <HistoryP2P v-if="state.token" />
        </div>
      </div>
      <div class="left-column">
        <ShopNav v-if="state.token" />
        <Shop :key="$route.params.tradeTo + $route.params.tradeFrom + 'shop'" />
      </div>
    </div>
  </div>
</template>
<script>
import SideBar from "../Public/SideBar.vue";
import CoinHeader from "./CoinHeader.vue";
import TradingView from "./TradingView.vue";
import CoinList from "./CoinList.vue";
import LastTrades from "./LastTrades.vue";
import Defth from "./Defth.vue";
import HistoryP2P from "./HistoryP2P.vue";
import ShopNav from "./ShopNav.vue";
import Shop from "./Shop.vue";
import { Loop, tradeFrom, tradeTo } from "@/library/reuseableFunction";

export default {
  name: "P2PContainer",
  metaInfo: {
    title: `معامله حرفه ای`,
  },
  components: {
    SideBar,
    CoinHeader,
    TradingView,
    CoinList,
    LastTrades,
    Defth,
    HistoryP2P,
    ShopNav,
    Shop,
  },
  data() {
    return {
      checked: this.state.theme === "light",
      loop: undefined,
      marketTradeInfo: {
        lastPrice: "",
        minPrice: "",
        maxPrice: "",
        last24HourChange: "",
        last24HourVolume: "",
      },
      tickerPrices: [],
    };
  },
  methods: {
    changeTheme() {
      if (this.checked) {
        this.state.theme = "light";
        localStorage.theme = "light";
        document.body.classList.remove("dark");
      } else {
        this.state.theme = "dark";
        localStorage.theme = "dark";
        document.body.classList.add("dark");
      }
    },
    async getPrices() {
      const res = await this.$axios.get("/trades/market-info", {
        params: {
          market_type: this.tradeFrom + "_" + this.tradeTo,
          source_coin: this.tradeTo,
        },
      });
      this.marketTradeInfo = res.marketTradeInfo;
      this.tickerPrices = res.tickerPrices;
      this.state.shopInfo.lastTrade = res.marketTradeInfo.lastPrice;

      this.sort();
      this.loading = false;
    },
    sort() {
      this.tickerPrices.sort(
        (a, b) =>
          this.$sortCoins.indexOf(a.sourceCoinSymbol) -
          this.$sortCoins.indexOf(b.sourceCoinSymbol)
      );
    },
  },
  computed: {
    tradeFrom,
    tradeTo,
  },
  mounted() {
    this.loading = true;
    this.loop = new Loop(this.getPrices, 3000, "homeChart" + "TETHER");
    if (this.state.loop) {
      this.loop.start();
    } else {
      this.getPrices();
    }
  },
  beforeDestroy() {
    this.loop?.stop();
  },
};
</script>
<style lang="scss" scoped>
.pad-top {
  padding-top: 75px;
}
.market-view {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: 38%;
}
.trades-defth {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  max-height: 30%;
}
.content-container {
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  // padding:0 8px;
  padding-right: 95px;
  padding-left: 12px;
  background: var(--home-background);
  width: 100%;
  height: 100%;
  row-gap: 8px;
}
.right-column {
  width: 80%;
  display: flex;
  flex-direction: row;
  height: 100%;
}
.left-column {
  left: 0;
  top: 0;
  background: var(--box);
  position: absolute;
  width: 20%;
  display: flex;
  flex-direction: column;
}
.dashboard-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .headet-tabs {
    background: var(--home-background);
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 10px 95px 10px 40px;
    .navbar {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      column-gap: 40px;
      padding: 18px;
      width: 80%;
      @media (max-width: 1300px) {
        width: 100%;
      }
      > div {
        display: flex;
        column-gap: 40px;
      }
      a {
        color: var(--grey);
        font-weight: 400;
        font-size: clamp(11px, 1vw, 14px);
      }
    }
  }
}
.column-container {
  display: flex;
  flex-direction: row;
  width: 100%;
}
@media only screen and (max-width: 1300px) {
  .left-column {
    position: unset !important;
    background: var(--home-background) !important;
  }
  .column-container {
    flex-direction: column;
    row-gap: 20px;
    background: var(--home-background);
  }
  .right-column {
    width: 100%;
  }
  .left-column {
    order: -1;
    width: 100%;
    padding: 0px 40px;
    align-items: center;
    padding-right: 120px;
  }
  .headet-tabs {
    padding: 10px 120px 10px 10px !important;
  }
}
@media only screen and (max-width: 1000px) {
  .market-view {
    flex-direction: column;
    row-gap: 12px;
    .coinslist {
      order: 2;
    }
  }
  .trades-defth {
    flex-direction: column;
    row-gap: 12px;
  }
}
@media only screen and (max-width: 600px) {
  .left-column {
    padding: 0 48px 0px 12px;
  }
  .headet-tabs {
    padding: 10px 48px 10px 12px !important;
  }
  .content-container {
    padding-right: 48px;
  }
  .navbar {
    column-gap: 10px !important;
  }
}
.switch {
  height: 40px;
  width: 85px;
  /*flex-basis: 85px;*/
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  background-color: var(--light-grey);
  position: relative;
  align-items: center;
  margin: 0;
  border-radius: 5px;
  margin-right: 8px;
  direction: ltr;
  @media (max-width: 600px) {
    height: 30px;
    width: 61px;
    margin-right: 4px;
  }

  .sun {
    z-index: 99;
    right: 0;
    width: 50%;
    height: 20px;
    cursor: pointer;
    @media (max-width: 600px) {
      height: 12px;
    }
  }

  .moon {
    z-index: 99;
    left: 0;
    width: 50%;
    height: 20px;
    cursor: pointer;
    @media (max-width: 600px) {
      height: 12px;
    }
  }
  input {
    opacity: 0;
    width: 100%;
    height: 100%;
  }
  .slider {
    position: absolute;
    cursor: pointer;
    top: 50%;
    transform: translate(-50%, -50%);
    left: 25%;
    background-color: var(--dark-primary);
    width: calc(50% - 10px);
    height: calc(100% - 10px);
    border-radius: 5px;
    transition: 0.4s;
  }

  input:checked + .slider {
    box-shadow: none;
    left: 75%;
  }
}
</style>
